;(function () {
	const initMulticolumn = () => {
		const multicolumnSections = document.querySelectorAll('.multicolumn-section')

		multicolumnSections.forEach((multicolumnSection) => {
			const multicolumnSwipeEnabled = multicolumnSection.querySelector('.swiper--multicolumn')
			if (!multicolumnSwipeEnabled) return

			let swiperMulticolumn

			const initSlider = () => {
				if (swiperMulticolumn) return
				multicolumnSwipeEnabled.classList.add('multicolumn-swiper-wrapper')
				const slides = multicolumnSection.querySelectorAll('.multicolumn-list__item')
				slides.forEach((slide) => {
					slide.classList.add('swiper-slide')
				})
				/* No loop (2026-09-30): the slider stops at the first and last step.
				   Swiper then marks the previous arrow disabled on the first slide and
				   the next arrow disabled on the last one (see section-multicolumn.css). */
				swiperMulticolumn = new Swiper(multicolumnSwipeEnabled, {
					loop: false,
					rewind: false,
					slidesPerView: 1,
					spaceBetween: 0,
					navigation: {
						nextEl: multicolumnSection.querySelector('.multicolumn-button-next'),
						prevEl: multicolumnSection.querySelector('.multicolumn-button-prev'),
					},
				})
			}

			const destroySlider = () => {
				if (!swiperMulticolumn) return
				multicolumnSwipeEnabled.classList.remove('multicolumn-swiper-wrapper')
				const slides = multicolumnSection.querySelectorAll('.multicolumn-list__item')
				swiperMulticolumn.destroy(true, true)
				swiperMulticolumn = undefined
				slides.forEach((slide) => {
					slide.removeAttribute('style')
					slide.classList.remove('swiper-slide')
				})
			}

			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				if (entry.contentRect.width < 990) {
					initSlider()
				} else {
					destroySlider()
				}
			})

			sectionResizeObserver.observe(multicolumnSection)
		})
	}

	initMulticolumn()
	document.addEventListener('shopify:section:load', () => {
		initMulticolumn()
	})
})()
